import { createContext, SetStateAction, Dispatch } from "react";
import { GenerateAPQuotationServiceRequest } from "../../../../../../../../shared/interfaces";

interface WizardDataFormContextProps {

    quotationForm:             GenerateAPQuotationServiceRequest | undefined;
    setQuotationForm:          Dispatch<SetStateAction<GenerateAPQuotationServiceRequest | undefined>>
}

export const WizardDataFormContext = createContext({} as WizardDataFormContextProps);